import {Injectable} from '@angular/core';
import {Observable, throwError} from 'rxjs';
import {HttpClient, HttpErrorResponse} from '@angular/common/http';
import {catchError} from 'rxjs/operators';
import {TaxplanIQServices} from "../services/TaxplanIQServices";
import {SOURCE_TYPE} from "../constants/Tpiq.constants";

export function getAllEventsDataUrl(org, userId) {
  return `/TaxPlanningServices/org/${org}/users/${userId}/events`;
}

export function createOrEditEventUrl(org, userId) {
  return `/TaxPlanningServices/org/${org}/users/${userId}/events`;
}

export function getRemoveEventUrl(org, userId, eventId) {
  return `/TaxPlanningServices/org/${org}/users/${userId}/events/${eventId}`;
}


@Injectable({
  providedIn: 'root'
})
export class EventsService extends  TaxplanIQServices {

  options = {};
  constructor(http: HttpClient) {
    super(http);
  }

  createOrEditEvent(org, userId, obj): Observable<any> {
    const url = createOrEditEventUrl(org, userId);
    return this.create(url, obj, SOURCE_TYPE.JAVA).pipe(catchError(this.handleError));
  }
  removeEvent(org, userId, eventId): Observable<any> {
    const url = getRemoveEventUrl(org, userId, eventId);
    return this.delete(url, SOURCE_TYPE.JAVA).pipe(catchError(this.handleError));
  }

  getAllEvents(org, userId): Observable<any> {
    const url = getAllEventsDataUrl(org, userId);
    return this.query(url, SOURCE_TYPE.JAVA).pipe(catchError(this.handleError));
  }

  private handleError(error: HttpErrorResponse): any {
    return throwError(error.error);
  }

}
